import { http } from '../../config/axios'

const findPlano = (params: any): Promise<any> => {
  const { first, rows, page, sortField, sortOrder, descricao, ativo } = params;
  const idFranquia = (params.idFranquia !== null && params.idFranquia !== undefined) ? params.idFranquia : 'null';

  const path = `api/plano/find/${first}/${rows}/${page}/${idFranquia}/${sortField}/${sortOrder}`;

  const queryParams: Record<string, any> = {};
  if (descricao != null && descricao !== '') {
    // busca no backend e LIKE contains: nbsp/quebras de linha/espacos duplos e reticencias
    // de copy/paste de relatorio quebram o match se nao forem normalizados aqui
    const descricaoSanitizada = String(descricao)
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .normalize('NFC')
      .replace(/[ ​-‍﻿]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/[.…]+$/, '')
      .trim();
    if (descricaoSanitizada) {
      queryParams.descricao = descricaoSanitizada;
    }
  }
  if (ativo !== null && ativo !== undefined) {
    queryParams.ativo = ativo;
  }

  return http
    .get(path, { params: queryParams })
    .then((res) => {
      if (res.data && res.data.planos && res.data.planos.length > 0) {
        res.data.planos.forEach((p: any) => {
          p.planosServico.forEach((ps: any) => {
            ps.planosServicoValor.forEach((psv: any) => {
              psv.data = new Date(psv.data)
            });
            ps.planosServicoValor.sort((a: any, b: any) => a.data.getTime() - b.data.getTime());
          });
        });
      }
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findPlano', error)
      throw Error(error.response.data)
    })
}

export default findPlano;
